import { Text } from "@chakra-ui/react";
import { Tooltip } from "../ui/chakra/tooltip";

export const getStockStatus = (stock: number, minimumStock: number) => {
  let color = "fg";
  let tooltipLabel = "Stock óptimo";

  if (stock < minimumStock) {
    color = "red.600";
    tooltipLabel = "Stock crítico: menor al stock mínimo";
  } else if (stock <= minimumStock + 5) {
    color = "orange.500";
    tooltipLabel = "Stock por alcanzar el mínimo";
  }

  return (
    <Tooltip content={tooltipLabel}>
      <Text color={color} fontWeight={color === "fg" ? undefined : "semibold"}>
        {stock}
      </Text>
    </Tooltip>
  );
};
export const TYPECONVERT = ["Multiplicador", "Divisorio"];
export const UNIDADES = [
  "KT",
  "RL",
  "BL",
  "LT",
  "GN",
  "PT",
  "MT",
  "CJ",
  "TR",
  "CU",
  "AE",
  "BI",
  "BN",
  "UN",
  "BT",
  "CT",
  "TB",
  "KG",
  "BO",
  "GA",
  "LM",
];
